import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { HelmetProvider } from 'react-helmet-async';
import theme from './theme';
import Layout from './components/Layout';
import AppRoutes from './routes';
import AdminLogin from './pages/AdminLogin';
import { Box } from '@mui/material';
import { initGA } from './utils/analytics';
import { useAnalytics } from './hooks/useAnalytics';
import RequestMovie from './pages/RequestMovie';

const ADMIN_SECRET_PATH = '/movie-admin-2024';

const AppContent = () => {
  const location = useLocation();
  useAnalytics(); // Track page views

  // If it's the admin path, render AdminLogin directly
  if (location.pathname === ADMIN_SECRET_PATH) {
    return <AdminLogin />;
  }

  // Otherwise wrap in Layout
  return (
    <Layout>
      <AppRoutes />
    </Layout>
  );
};

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <AppContent />
        </Box>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
